import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DropDownButton from 'components/form/DropDownButton';
import { keyIn } from 'utils/immutable';

class LanguageDropDown extends React.Component {
    constructor(props) {
        super(props);

        this.state = { selectedLanguage: '' };

        this.handleLanguageClick = this.handleLanguageClick.bind(this);
    }

    handleLanguageClick(e) {
        this.setState(
            { selectedLanguage: e.target.dataset.langCode },
            () => this.languageForm.submit()
        );
    }

    render() {
        if (this.props.gateway && !this.props.isGatewayLocalized) {
            return null;
        }

        return (
            <DropDownButton id="LanguageChooser" label={this.props.currentLanguage}>
                <form
                    ref={(c) => { this.languageForm = c; }}
                    method="post"
                    action={Util.reverseURL('dblocale:set_databasin_language')}
                >
                    <input name="next" type="hidden" value={window.location.pathname} />
                    <input name="language" type="hidden" value={this.state.selectedLanguage} />
                    <ul style={{ fontSize: '1.2em' }} className="languageList">
                        {this.props.languages.map(lang =>
                            (<li
                                key={lang.code}
                                className="languageOption"
                                data-lang-code={lang.code}
                                style={{ textTransform: 'capitalize' }}
                                onClick={this.handleLanguageClick}
                            >
                                {lang.name_local}
                            </li>
                            ))}
                    </ul>
                </form>
            </DropDownButton>
        );
    }
}

LanguageDropDown.propTypes = {
    currentLanguage: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
        name_local: PropTypes.string
    })),
    gateway: PropTypes.string,
    isGatewayLocalized: PropTypes.bool
};

LanguageDropDown.defaultProps = {
    languages: [],
    gateway: '',
    isGatewayLocalized: false
};

const mapStateToProps = state => state
    .get('site')
    .filter(keyIn('currentLanguage', 'languages', 'gateway', 'isGatewayLocalized'))
    .toJS();

export default connect(mapStateToProps)(LanguageDropDown);



// WEBPACK FOOTER //
// ./source/containers/SiteHeaderBar/LanguageDropDown.jsx